// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeletonLoader_skeleton__4RCba","shimmer":"skeletonLoader_shimmer__Zk4yV"};